<template>
  <div class="nav-logo" >
    <a :href="doxoUrl">
      <div class="nav-logo__top-image" />
    </a>
    <a :href="tryDoxoPlusUrl">
      <div class="nav-logo__bottom-image" />
    </a>

  </div>
</template>

<script>
  import siteUrls, { enableMicroApp } from '@/helpers/site_urls'
  import { mapGetters, mapState } from 'vuex'

  export default {
    siteUrls,
    computed: {
      ...mapGetters('user', ['isLoggedIn']),
      ...mapState('user', ['userData']),
      doxoUrl () {
        return enableMicroApp ? siteUrls.microAppBills : (this.isLoggedIn ? siteUrls.secureSite : siteUrls.homeUrl)
      },
      tryDoxoPlusUrl () {
        return enableMicroApp ? siteUrls.microAppBills : (this.isLoggedIn ? this.newSubscriptionUrl : siteUrls.doxoplusMarketingPath)
      },
      newSubscriptionUrl () {
        return `${siteUrls.userSite}/subscriptions/new`
      }
    }
  }
</script>

<style lang="stylus">
  .nav-logo {
    position: relative
    padding: 0
    width: 108px
    height: 42px
    background: top 0 left 0
    background-repeat: no-repeat
    margin: 0
    &__top-image {
      background-image: url('~assets/images/logos/logo_reversed_flat.svg')
      background-size: 108px
      width: 108px
      height: 35px
    }
    &__bottom-image {
      background-image: url('~assets/images/logos/doxotryPLUS-no-link.svg')
      background-size: 70px
      margin: -10px 0 0 46px
      width: 70px
      height: 30px

      &:hover {
        background-image: url('~assets/images/logos/doxotryPLUS-link.svg')
      }
    }
  }
</style>



// WEBPACK FOOTER //
// frontend/src/components/common/NavLogo.vue